// Lightweight Web Audio API bell — fallback when no custom audio uploaded.
// Generates a pleasant 2-tone bell entirely in-browser, no asset needed.

let _ctx = null;

function getCtx() {
  if (typeof window === "undefined") return null;
  if (_ctx && _ctx.state !== "closed") return _ctx;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  _ctx = new AC();
  return _ctx;
}

export function unlockAudio() {
  // iOS/Safari requires unlock from a user gesture
  const c = getCtx();
  if (c && c.state === "suspended") {
    c.resume().catch(() => {});
  }
}

export function playBell({ volume = 0.4 } = {}) {
  const c = getCtx();
  if (!c) return;
  if (c.state === "suspended") c.resume().catch(() => {});

  const now = c.currentTime;
  // Two-tone "ding-dong" — high then low
  const tones = [
    { freq: 880, start: 0, dur: 0.35 },
    { freq: 660, start: 0.18, dur: 0.45 },
  ];

  tones.forEach(({ freq, start, dur }) => {
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.0001, now + start);
    gain.gain.exponentialRampToValueAtTime(volume, now + start + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + start + dur);
    osc.connect(gain);
    gain.connect(c.destination);
    osc.start(now + start);
    osc.stop(now + start + dur + 0.05);
  });
}

export function playDataUrl(dataUrl, { volume = 1.0 } = {}) {
  try {
    const audio = new Audio(dataUrl);
    audio.volume = Math.max(0, Math.min(1, volume));
    audio.play().catch(() => playBell()); // fallback
  } catch {
    playBell();
  }
}
